export default "__VITE_ASSET__DMJGzOZr__"